import React from 'react';
import { ArticleHeading3, ArticleHeading4, UIText2, UIText3 } from '@cian/ui-kit';
import { transformNumToString } from 'shared/utils/common';
import { PERCENT } from 'shared/constants/common';

import styles from './styles.css';
import { IOfferRate } from '../../../../repositories/mortgage-broker-calculator/entities/mortgage_listing/OfferRate';
import { useIsDesktop } from '../../../../hooks/common';

export interface IRateBlockProps {
  rate: IOfferRate;
}

export const RateBlock: React.FC<IRateBlockProps> = ({ rate: { discount, rateWithDiscount, rate } }) => {
  const isDesktop = useIsDesktop();

  const rateBody = (
    <div className={styles['rate-block']}>
      {discount && rateWithDiscount ? (
        <>
          {transformNumToString(rateWithDiscount)}
          {PERCENT}
          <div className={styles['discount-rate-block']}>
            <UIText3 color={'current_color'}>
              -{transformNumToString(discount)}
              {PERCENT}
            </UIText3>
          </div>
          <div className={styles['full-rate-block']}>
            <UIText2 color={'current_color'}>
              {transformNumToString(rate)}
              {PERCENT}
            </UIText2>
          </div>
        </>
      ) : (
        <>
          {transformNumToString(rate)}
          {PERCENT}
        </>
      )}
    </div>
  );

  return (
    <>
      <div className={styles['title']}>
        <UIText2 color={'current_color'}>Ставка</UIText2>
      </div>
      {isDesktop ? <ArticleHeading4>{rateBody}</ArticleHeading4> : <ArticleHeading3>{rateBody}</ArticleHeading3>}
    </>
  );
};
